import * as React from "react";
import type { SVGProps } from "react";
const SvgPhobum2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 69 16"
    {...props}
  >
    <path
      fill="#4FD08F"
      d="M.5 15.5V.833h6.667v1.334H1.833v6.666h5.334v1.334H1.833V15.5zm6.667-6.667V7.5H8.5v1.333zm0-6.666H8.5V3.5H7.167zM8.5 7.5v-4h1.333v4zm2.672 8V.833h1.333V7.5h6.667V.833h1.333V15.5h-1.333V8.833h-6.667V15.5zm10.672-2.667V3.5h1.333v9.333zm10.666 0h-1.333V3.5h1.333zm-9.333 0h1.333v1.334h-1.333zm0-9.333V2.167h1.333V3.5zm1.333 10.667h5.334V15.5H24.51zm0-12V.833h5.334v1.334zm5.334 12v-1.334h1.333v1.334zm0-12h1.333V3.5h-1.333zm4 13.333V.833h6.666v1.334h-5.333V7.5h5.333v1.333h-5.333v5.334h5.333V15.5zm8-2.667v1.334H40.51v-1.334zm0-4v1.334H40.51V8.833zm0 1.334h1.333v2.666h-1.333zm0-4V7.5H40.51V6.167zm0-4V3.5H40.51V2.167zm0 1.333h1.333v2.667h-1.333zm2.672 9.333v-12h1.333v12zm10.666 0H53.85v-12h1.333zm-9.333 0h1.333v1.334H45.85zm1.333 1.334h5.334V15.5h-5.334zm5.334 0v-1.334h1.333v1.334zm16-13.334V15.5h-1.334V4.833H65.85V2.167h1.333V.833zm-12 14.667V.833h1.333v1.334h1.333v2.666H57.85V15.5zm2.666-6.667v-4h1.334v4zm2.667 4h1.333V15.5H61.85zm0-4v4h-1.333v-4zm2.667 4h-1.334v-4h1.334zm0-4v-4h1.333v4z"
    />
  </svg>
);
export default SvgPhobum2;
